module.exports = __webpack_public_path__ + "f84e10d36b1e23f92f3bc89515183026.pdf";